import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from "@angular/router";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ToastService } from "src/app/services/toast.service";
import { sntTranslate } from "src/app/support/translate";
import { environment } from "src/environments/environment";

@Injectable()
export class RocketBackupStickyToastGuard implements CanActivate {
  private readonly bootsrapService = inject(BootstrapService);
  private readonly toastService = inject(ToastService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const configuration = this.bootsrapService.getCurrentConfiguration()!;

    if (!configuration.backup || !configuration.backup.enabled) {
      setTimeout(() => {
        this.toastService.warning({
          title: sntTranslate(
            marker(
              "Il backup non è ancora stato configurato. Per assicurare la sicurezza dei tuoi dati, configuralo al più presto!"
            )
          ),
          sticky: true,
          displayTime: 60 * 1000 * 5,
          action: {
            label: sntTranslate(marker("Scopri come")),
            action: () => {
              window.open(
                environment.snoots.helpcenter.urls.enable_backup,
                "_blank"
              );
            }
          }
        });
      }, 500);
    }

    return true;
  }
}
